import { configureStore } from '@reduxjs/toolkit'
import alertsReducer from './features/alerts/alertsSlice'
import authReducer from './features/auth/authSlice'
import currentUserReducer from './features/currentUser/currentUserSlice'

export const store = configureStore({
    reducer: {
        alerts: alertsReducer,
        auth: authReducer,
        currentUser: currentUserReducer,
    },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>